import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import downloadIcon from '../assets/icons/download.svg';

const getFileIcon = (fileName = '') => {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'file pdf outline';
  if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tif', 'tiff'].includes(ext)) {
    return 'file image outline';
  }
  if (['doc', 'docx', 'rtf', 'odt'].includes(ext)) return 'file word outline';
  if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) return 'file excel outline';
  if (['ppt', 'pptx'].includes(ext)) return 'file powerpoint outline';
  if (ext === 'txt') return 'file text outline';
  return 'file alternate outline';
};

const getFileIconColor = (fileName = '') => {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'red';
  if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tif', 'tiff'].includes(ext)) return 'purple';
  if (['doc', 'docx', 'rtf', 'odt'].includes(ext)) return 'blue';
  if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) return 'green';
  if (['ppt', 'pptx'].includes(ext)) return 'orange';
  return 'grey';
};

const AttachmentItem = ({ fileName, downloadUrl, small }) => {
  const baseUrl = downloadUrl || '';
  const hasDl = baseUrl.includes('dl=true');
  const separator = baseUrl.includes('?') ? '&' : '?';
  const forceDownloadUrl = !baseUrl ? null : (hasDl ? baseUrl : `${baseUrl}${separator}dl=true`);

  const viewUrl = !baseUrl ? null : baseUrl.replace('?dl=true', '').replace('&dl=true', '');

  return (
    <div className={`attachment-item-row${small ? ' attachment-item-row--small' : ''}`}>

      <div className="attachment-preview-container">
        <Icon
          name={getFileIcon(fileName)}
          size={small ? 'small' : 'large'}
          color={getFileIconColor(fileName)}
          style={{ margin: 0, flexShrink: 0 }}
        />

        <a
          className="attachment-item-link"
          href={viewUrl}
          title={`${fileName || 'Attachment'} (Preview)`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="doc-name">{fileName || 'Attachment'}</span>
        </a>
      </div>

      <a
        className="attachment-download-link"
        href={forceDownloadUrl}
        title={`Download ${fileName || 'Attachment'}`}
      >
        <img
          src={downloadIcon}
          alt="download"
          className="attachment-download-icon"
          style={{ marginLeft: '4px' }}
        />
      </a>
    </div>
  );
};

AttachmentItem.propTypes = {
  fileName: PropTypes.string,
  downloadUrl: PropTypes.string.isRequired,
  small: PropTypes.bool,
};

export default AttachmentItem;



// WEBPACK FOOTER //
// ./src/components/AttachmentItem.jsx